import t from "styled-components";
import { breakpoints as s } from "./atoms-v2125.js";
import { INPUT_EXPRESSIVE_HEIGHT as n, INPUT_PRODUCTIVE_HEIGHT_SMALL as e, INPUT_PRODUCTIVE_HEIGHT as a } from "./atoms-v2810.js";
import { getColor as p } from "./atoms-v2815.js";
const d = ({
  hasValue: o,
  isFocused: r,
  variant: i
}) => (o || r) && i === "productive" ? "translateY(-0.51em) scale(0.89)" : (o || r) && i === "expressive" ? "translateY(-0.57em) scale(0.7)" : "none", v = t.label`
  ${({ $variant: o, theme: r }) => {
  var i;
  return (i = r == null ? void 0 : r.get(o === "expressive" ? "tokens.heading.03" : "tokens.body.productive")) == null ? void 0 : i.toJS();
}}
  align-items: center;
  color: ${({ $colorTheme: o = "light", $isDisabled: r, theme: i }) => p({ colorTheme: o, disabled: r, theme: i })};
  display: flex;
  height: ${({ $variant: o }) => o === "expressive" ? n : e}px;
  inset: 0 0 0 var(--padding-x);
  pointer-events: none;
  position: absolute;
  transform: ${({ $hasValue: o, $isFocused: r, $variant: i }) => d({ hasValue: o, isFocused: r, variant: i })};
  transform-origin: left top;
  transition: transform ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")}
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};
  z-index: 1;

  @media ${s.medium} {
    ${({ $variant: o, theme: r }) => {
  var i;
  return (i = r == null ? void 0 : r.get(o === "expressive" ? "tokens.heading.03" : "tokens.body.expressive")) == null ? void 0 : i.toJS();
}}
    height: ${({ $variant: o }) => o === "expressive" ? n : a}px;
  }
`;
export {
  v as Label
};
